import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers, directoryReducers } from './listConstants'

const unassignedCompaniesListSlice = createSlice({
    name: 'ui/unassigned-companies-list',
    initialState: {
        ...initialState,
        openSideFilter: false,
        expandedContactKeys: [],
        expandedContactTreeKeys: [],
        expandedRowKeys: [],
        filters: { ...initialState.filters, userType: 'all' },
        pureFilters: { ...initialState.pureFilters, userType: 'all' }
    },
    reducers: {
        ...listReducers,
        onResetFilters(state) {
            state.filters = { userType: 'all' }
            state.pureFilters = { userType: 'all' }
        },
        changeSideFilterVisibility(state, action) {
            state.openSideFilter = action.payload
        },
        ...directoryReducers
    }
})

export const unassignedCompaniesListActions = unassignedCompaniesListSlice.actions
export default unassignedCompaniesListSlice.reducer
